import React, { useState } from "react";

export default function useUser() {
  const getUser = () => {
    return sessionStorage.getItem("user_credential");
  };

  const [user, setUser] = useState(getUser());

  const saveUser = (user_credential) => {
    sessionStorage.setItem("user_credential", JSON.stringify(user_credential));
    setUser(user_credential);
  };

  return {
    setUser: saveUser,
    user,
  };
}
